import _ from 'lodash';
import React from 'react';
import { wipeBrazeSdkOnSignOut } from '../../../../services/braze/braze-user-identity';

export default function buildStaticMenus(userSignedIn) {
  const profile = _.get(window, 'Livewire.currentUser.profile');
  const canPostWires = _.get(profile, 'canPostWires');
  const slug = _.get(profile, 'slug');
  const activePartnership = _.get(profile, 'activePartnership');
  const discoverFundsEnabled = _.get(window, 'Livewire.features.discoverFunds');

  const dashboardItem = {
    text: 'Analytics',
    anchor: {
      href: '/analytics/performance',
    },
  };

  return {
    ...(canPostWires ? { 'Write a wire': '/wires/new' } : {}),
    Latest: '/feeds/latest',
    ...(discoverFundsEnabled ? {} : { Trending: '/feeds/trending' }),
    ...(discoverFundsEnabled ? { Funds: '/funds' } : {}),
    Contributors: '/contributors',
    Categories: [],
    Series: [],
    separator: () => <hr />,
    ...(!userSignedIn ? {} : {
      Account: [
        { text: 'Likes', anchor: { href: '/likes' } },
        { text: 'Saved Wires', anchor: { href: '/profiles/me/saved_wires' } },
        { text: 'Notifications', anchor: { href: '/profiles/me/notifications' } },
        { text: 'My Profile', anchor: { href: '/profiles/me/personal_details' } },
        ...(!canPostWires ? [] : [
          { text: 'My Wires', anchor: { href: `/contributors/${slug}?tab=wires#wires` } },
          { text: 'My Drafts', anchor: { href: `/contributors/${slug}?tab=drafts#drafts` } },
        ]),
        ...(activePartnership ? [dashboardItem] : []),
        { text: 'Email Preferences', anchor: { href: '/profiles/me/notification_preferences' } },
        {
          text: 'Sign Out',
          anchor: {
            href: '/users/sign_out',
            'data-method': 'delete',
            onClick: wipeBrazeSdkOnSignOut,
          },
        },
      ],
    }),
    Company: [
      { text: 'About Livewire', anchor: { href: '/company/home' } },
      { text: 'Contact Us', anchor: { href: '/company/our_story#contact_us' } },
    ],
    Events: [],
  };
}
